const getTeamId = source => {
	return source.run ? source.run.team_id : source.tasks[0].team_ids[0];
};

export default getTeamId;
